import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';

export const BootstrapDialog = styled(Dialog)(({ theme, maxWidth, props }) => ({
  '& .MuiDialog-paper': {
    [theme.breakpoints.down(maxWidth)]: {
      minWidth: '100%',
      maxWidth: '100%',
    },
    [theme.breakpoints.up(maxWidth)]: {
      minWidth:
        maxWidth === 'md'
          ? '500px'
          : maxWidth === 'lg'
            ? '700px'
            : maxWidth === 'xl'
              ? '900px'
              : '500px',
      maxWidth:
        maxWidth === 'md'
          ? '500px'
          : maxWidth === 'lg'
            ? '700px'
            : maxWidth === 'xl'
              ? '900px'
              : '500px',
    },
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& .MuiDialogTitle-root': {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
  },
  ...props,
}));
